/* eslint-disable */
'use strict';

import domains from './config-environment';

const env = process.env.VUE_APP_ENV,
	region = environment.region,
	currentDomain = domains[env][region];

const locale = window.Gnb && window.Gnb.$i18n && window.Gnb.$i18n.locale ? window.Gnb.$i18n.locale : '';

export default {
	languages: {
		global: ['es-419', 'en-US', 'pt-BR', 'de-DE', 'nl-NL', 'fr-FR', 'it-IT', 'pl-PL', 'tr-TR', 'ru-RU'],
		one: ['es-419', 'en-US', 'pt-BR', 'de-DE', 'nl-NL', 'fr-FR', 'it-IT', 'pl-PL', 'tr-TR', 'th-TH', 'zh-TW', 'ru-RU'],
		th: ['th-TH'],
		tw: ['zh-TW'],
		sea: ['en-US'],
	},
	externalRegionLinks: {
		global: domains[env].global,
		one: domains[env].one,
		th: domains[env].th,
		tw: domains[env].tw,
		sea: domains[env].sea,
		kr: 'https://www.nexon.com/Home/Game.aspx',
		jp: 'https://jp.nexon.com/',
	},
	footerBottomLinks: {
		global: [
			{
				name: 'press',
				url: 'https://en-newsroom.nexon.com/',
			},
			{
				name: 'investorRelations',
				url: 'https://ir.nexon.co.jp/en/',
			},
			{
				name: 'privacy',
				url: `${currentDomain}/main${locale ? `/${locale}` : ''}/legal/privacy/`,
			},
			{
				name: 'legalDoc',
				url: 'https://playersupport.nexon.com/hc/en-us/categories/200870546-Legal',
			},
		],
		one: [
			{
				name: 'press',
				url: 'https://en-newsroom.nexon.com/',
			},
			{
				name: 'investorRelations',
				url: 'https://ir.nexon.co.jp/en/',
			},
			{
				name: 'privacy',
				url: `${currentDomain}/main${locale ? `/${locale}` : ''}/legal/privacy/`,
			},
			{
				name: 'legalDoc',
				url: 'https://playersupport.nexon.com/hc/en-us/categories/200870546-Legal',
			},
		],
		th: [
			{
				name: 'privacy',
				url: currentDomain + '/main/legal/privacy/',
			},
			{
				name: 'privacyPolicyMatrix',
				url: `${currentDomain}/main${locale ? `/${locale}` : ''}/legal/privacy-policy-matrix`,
			},
			{
				name: 'tou',
				url: currentDomain + '/main/legal/tou/',
			},
			{
				name: 'tos',
				url: currentDomain + '/main/legal/terms-of-sale',
			},
		],
		tw: [
			{
				name: 'privacy',
				url: currentDomain + '/main/legal/privacy/',
			},
			{
				name: 'privacyPolicyMatrix',
				url: `${currentDomain}/main${locale ? `/${locale}` : ''}/legal/privacy-policy-matrix`,
			},
			{
				name: 'tou',
				url: currentDomain + '/main/legal/tou/',
			},
		],
		sea: [
			{
				name: 'privacy',
				url: currentDomain + '/main/legal/privacy/',
			},
			{
				name: 'privacyPolicyMatrix',
				url: `${currentDomain}/main${locale ? `/${locale}` : ''}/legal/privacy-policy-matrix`,
			},
			{
				name: 'tou',
				url: currentDomain + '/main/legal/tou/',
			},
			{
				name: 'investorRelations',
				url: 'https://ir.nexon.co.jp/en/',
			},
		],
	},
};
